import * as React from 'react'
import { useMemo } from 'react'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import type { ConditionModel } from '../../../typings'
import { useTranslation } from 'react-i18next'
import Divider from '@mui/material/Divider'
import { useTheme } from '@mui/material/styles'

type Props = {
  data: ConditionModel
  idx: number
}

export function ConditionItem(props: Props) {
  const {
    data: { assignmentRuleConditionValues, matchType, attribute },
    idx,
  } = props
  const theme = useTheme()
  const { t } = useTranslation()

  const values = useMemo(() => {
    const names = assignmentRuleConditionValues.map(
      (value: any) =>
        `${
          value?.name ||
          value?.label ||
          value?.fullName ||
          value?.value ||
          value
        }${value?.abbreviation ? ` (${value?.abbreviation})` : ''}${
          value?.description ? ` - ${value?.description}` : ''
        }`,
    )
    return ` ${names.join(', ')}`
  }, [assignmentRuleConditionValues])

  const title = useMemo(() => {
    switch (attribute) {
      case 'ZipCode':
        return t('postalCode')
      case 'Branch':
        return 'Branch'
      case 'Campaign':
        return 'Campaign'
      case 'LeadSource':
        return 'Lead Source'
      case 'State':
        return t('stateAssignmentRuleLabel')
      case 'LocationType':
        return 'Location Type'
      case 'Division':
        return 'Division'
      case 'CreatedBy':
        return 'Created By'
      case 'TargetPest':
        return 'Target Pests'
      case 'LeadType':
        return 'Type'
      default:
        return ''
    }
  }, [attribute, t])

  return (
    <Stack mt={2}>
      <Typography variant="subtitle3" color={theme.palette.text.primary}>
        {idx + 1}. {title}
      </Typography>
      <Typography
        variant="subtitle1"
        color={theme.palette.text.primary}
        letterSpacing={0.17}
        mb={2}
      >
        {matchType}: {values}
      </Typography>

      <Divider />
    </Stack>
  )
}
